import React, { useState, useEffect } from "react";
import "./Testimonials.css";
import TestimonialsStats from "./shared/TestimonialsStats";
import Axios from "axios";
// import placeholder from "../assets/images/candidates-testimonials/profile-placeholder.png";
import placeholder from "../assets/images/candidates-testimonials/placeholder.png";

const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="star-icon"
  >
    <path
      fillRule="evenodd"
      d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
      clipRule="evenodd"
    />
  </svg>
);

const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    className="google-icon"
  >
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.72 1.22 9.22 3.61l6.85-6.85C35.91 2.38 30.37 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.5 24.55c0-1.57-.14-3.09-.41-4.55H24v9.09h12.67c-.55 2.95-2.22 5.45-4.72 7.14l7.27 5.64C43.98 37.45 46.5 31.55 46.5 24.55z"
    />
    <path
      fill="#FBBC05"
      d="M10.54 28.41A14.5 14.5 0 0 1 9.5 24c0-1.53.27-3 .76-4.41l-7.98-6.19A23.91 23.91 0 0 0 0 24c0 3.84.92 7.48 2.56 10.78l7.98-6.37z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.37 0 11.72-2.09 15.63-5.68l-7.27-5.64c-2.02 1.36-4.61 2.16-8.36 2.16-6.26 0-11.57-4.22-13.46-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </svg>
);

const ArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="nav-icon"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);

const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="nav-icon"
  >
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const Testimonials = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [expandedCard, setExpandedCard] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Track window resize
  useEffect(() => {
    const loadReviews = async () => {
      try {
        const res = await Axios.get(
          `${process.env.REACT_APP_API_BASE_URL}php/get_reviews.php`,
        );
        console.log(res.data);

        if (res.data.success) {
          setTestimonials(res.data.reviews || []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    loadReviews();
  }, []);

  const isLongReview = (text) => text.length > 140;

  const getVisibleCount = () => {
    if (windowWidth < 768) return 1;
    if (windowWidth < 1024) return 2;
    return 3;
  };

  const visibleCount = getVisibleCount();

  // Step = visibleCount for web (3), always 1 for mobile
  const step = windowWidth >= 1024 ? 3 : windowWidth >= 768 ? 2 : 1;

  const handleNext = () => {
    setExpandedCard(null);
    setIsAnimating(true);
    setTimeout(() => {
      setStartIndex((prev) => (prev + step) % testimonials.length);
      setIsAnimating(false);
    }, 300);
  };

  const handlePrev = () => {
    setExpandedCard(null);
    setIsAnimating(true);
    setTimeout(() => {
      setStartIndex(
        (prev) => (prev - step + testimonials.length) % testimonials.length,
      );
      setIsAnimating(false);
    }, 300);
  };

  if (loading) {
    return null;
  }

  if (!loading && testimonials.length === 0) {
    return null;
  }

  const cardsToShow = Math.min(visibleCount, testimonials.length);

  const visibleTestimonials = Array.from({ length: cardsToShow }).map(
    (_, i) => testimonials[(startIndex + i) % testimonials.length],
  );

  const totalGroups = Math.ceil(testimonials.length / step);
  const currentGroup = Math.floor(startIndex / step) + 1;
  const progress = (currentGroup / totalGroups) * 100;

  return (
    <section className="testimonials-section">
      {/* Header Content */}
      <div className="testimonials-header">
        <p className="testimonials-subtitle">Thousands Trust Angel Gulf Jobs</p>
        <h2 className="testimonials-title">
          Don’t take our word for it, see what our candidates say
        </h2>
        <p className="testimonials-description">
          We’re honored by the feedback, and it fuels our commitment to
          delivering exceptional recruitment services. Read the reviews to hear
          firsthand how Angel Gulf Jobs is making a positive impact on people’s
          careers. Your trust is our greatest achievement.
        </p>
      </div>

      <div className={`testimonials-grid ${isAnimating ? "animating" : ""}`}>
        {visibleTestimonials.map((t) => (
          <div key={t.id} className="testimonial-card">
            <div className="testimonial-stars">
              {[...Array(Number(t.rating))].map((_, i) => (
                <div key={i} className="star-box">
                  <StarIcon />
                </div>
              ))}
            </div>

            {/* REVIEW TEXT */}
            <p
              className={`testimonial-text ${expandedCard === t.id ? "expanded" : ""}`}
            >
              {t.review_text}
            </p>

            {/* SEE MORE ONLY IF LONG */}
            {isLongReview(t.review_text) && expandedCard !== t.id && (
              <button
                className="read-more-btn"
                onClick={() => setExpandedCard(t.id)}
              >
                Read more
              </button>
            )}

            <div className="testimonial-author">
              <img
                src={
                  t.reviewer_image
                    ? `${process.env.REACT_APP_API_BASE_URL}php/uploads/reviews/${t.reviewer_image}`
                    : placeholder
                }
                alt={t.reviewer_name}
                className="author-image"
              />
              <div className="author-info mt-4">
                <h3>{t.reviewer_name}</h3>
                <p>
                  {new Date(t.review_date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Progress Bar */}
      <div className="testimonials-progress-container">
        <div
          className="testimonials-progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      {/* Footer / Google Reviews Section */}

      <div className="testimonials-footer">
        {/* Google Reviews Info */}
        <div className="trustpilot-container">
          <div className="trustpilot-top">
            <div className="trustpilot-logo">
              <GoogleIcon />
              <span className="trustpilot-text">Google Reviews</span>
            </div>

            <div className="rating-stars">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="star-box google-star-box">
                  <StarIcon />
                </div>
              ))}
            </div>

            <span className="rating-score">Excellent</span>
          </div>

          <p className="trustpilot-rating-text">
            {/* 4.9 Rating based on 10,000+ reviews */}
            Verified reviews from candidates placed successfully
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="testimonials-nav">
          <button
            className="nav-btn"
            onClick={handlePrev}
            aria-label="Previous"
          >
            <ArrowLeft />
          </button>

          <button className="nav-btn" onClick={handleNext} aria-label="Next">
            <ArrowRight />
          </button>
        </div>
      </div>

      <TestimonialsStats />
    </section>
  );
};

export default Testimonials;
